import type { PlayerResolvedAnimation } from '../types';
import { usePlayerStore } from '../store/playerStore';

const INITIAL_PLAYER_RESOLVED_ANIMATION: PlayerResolvedAnimation = {
  kind: 'none',
  bvh: null,
  bvhs: [],
  status: 'initial',
  isLoading: false,
  isReady: false,
  error: null,
};

export function usePlayerResolvedAnimation(actorId?: string) {
  const store = usePlayerStore();
  const resolvedActorId = actorId ?? store.state.activeActorId;

  if (!resolvedActorId) {
    return INITIAL_PLAYER_RESOLVED_ANIMATION;
  }

  void store.state.resolvedAnimationVersionByActorId[resolvedActorId];

  return (
    store.getResolvedAnimation(resolvedActorId) ??
    INITIAL_PLAYER_RESOLVED_ANIMATION
  );
}
